
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/agenda",
      function () {
        return require("private-next-pages/sa/agenda.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/agenda"])
      });
    }
  